import React from 'react';
import { Jumbotron, Button, Container } from 'react-bootstrap';
export const LectureCard = ({
  name,
  videourl,
  attachedDocument,
  sys,
  driveLink,
}) => {
  const [showSpinner, setSpinner] = React.useState(true);
  return (
    <div>
      <Jumbotron
        className='shadow-sm bg-light'
        fluid
        style={{ minHeight: '90vh' }}
      >
        <Container className='text-center'>
          <h4>{name}</h4>
          {showSpinner ? <p>Loading...</p> : <p>Video</p>}
          <p>Uploaded At</p>
          <p>{new Date(sys.publishedAt).toLocaleString()} PST</p>
          <div className='container rsvp-wrapper'>
            {driveLink.length > 0 ? (
              <iframe
                className='embed-responsive'
                src={driveLink}
                allowfullscreen='allowfullscreen'
                mozallowfullscreen='mozallowfullscreen'
                msallowfullscreen='msallowfullscreen'
                oallowfullscreen='oallowfullscreen'
                webkitallowfullscreen='webkitallowfullscreen'
                height='300'
                onLoad={() => setSpinner(false)}
                frameBorder='0'
                allow='encrypted-media'
                title={name}
              ></iframe>
            ) : (
              <iframe
                height='200'
                className='embed-responsive'
                onLoad={() => setSpinner(false)}
                allowfullscreen='allowfullscreen'
                mozallowfullscreen='mozallowfullscreen'
                msallowfullscreen='msallowfullscreen'
                oallowfullscreen='oallowfullscreen'
                webkitallowfullscreen='webkitallowfullscreen'
                src={videourl}
                allow='encrypted-media'
                title={name}
                frameBorder='0'
              ></iframe>
            )}

            {attachedDocument ? (
              <a rel='noreferrer' target='_blank' href={attachedDocument}>
                <Button className='my-3'>Attached Documents</Button>
              </a>
            ) : null}
          </div>
        </Container>
      </Jumbotron>
    </div>
  );
};
